// @index: export * from ${relpath}
export * from './decorators'
export * from './registry'
export * from './types'
// /index